import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {array, number, bool} from 'vue-types';
    import {reactive, ref, toRef, computed} from 'vue';
    import {IndustrySkill} from '@/profile-creation-wizard/components/for-creation/store';
    import {useTranslation} from '@malt/vue3-use';

    type IndustryExpertiseEvents = {
        (e: 'industry-expertise:updated', expertises: IndustrySkill[]): void;
        (e: 'industry-expertise:max-selection-reached'): void;
    };
    const noIcon = '';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'IndustryExpertise',
  props: {
        allExpertises: array<IndustrySkill>().isRequired,
        selectedExpertises: array<IndustrySkill>().isRequired,
        maxSelection: number().isRequired,
        responsive: bool().isRequired,
    },
  emits: ["industry-expertise:updated", "industry-expertise:max-selection-reached"],
  setup(__props, { emit }) {

const props = __props;

    const {msg} = useTranslation();

    

    

    const panelHeight = computed(() => (props.responsive ? '200px' : '300px'));

    const state = reactive<{selection: IndustrySkill[]; expertisesAvailable: IndustrySkill[]; max: number}>({
        selection: props.selectedExpertises,
        expertisesAvailable: toRef(props, 'allExpertises'),
        max: props.maxSelection,
    });

    const joyIconClassPanelOpened = ref<string>('');

    function handleOptionRemoved(event: CustomEvent) {
        state.selection = state.selection.filter((option) => option.label !== event.detail);
        emit('industry-expertise:updated', state.selection);
    }

    function handleSelectionChanged(): void {
        if (state.selection.length > state.max) {
            state.selection.pop();
            emit('industry-expertise:max-selection-reached');
            return;
        }
        emit('industry-expertise:updated', state.selection);
    }

    function handleDropDownOpened() {
        joyIconClassPanelOpened.value = 'p-multiselect-chevron-top';
    }

    function handleDropDownClosed() {
        joyIconClassPanelOpened.value = '';
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_icon = _resolveComponent("joy-icon")!
  const _component_joy_tag = _resolveComponent("joy-tag")!
  const _component_joy_tags_list = _resolveComponent("joy-tags-list")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!

  return (_openBlock(), _createBlock(_component_MultiSelect, {
    modelValue: state.selection,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.selection) = $event)),
    options: state.expertisesAvailable,
    optionLabel: "label",
    class: "joy-p-multiselect",
    showToggleAll: false,
    display: "chip",
    checkboxIcon: noIcon,
    scrollHeight: panelHeight.value,
    placeholder: _unref(msg)('profile.creation.completion.wizard.industry.expertise.placeholder'),
    "append-to": "self",
    "data-testid": "industry-expertise-multiselect",
    onChange: handleSelectionChanged,
    onShow: handleDropDownOpened,
    onHide: handleDropDownClosed
  }, {
    indicator: _withCtx(() => [
      _createVNode(_component_joy_icon, {
        class: _normalizeClass([joyIconClassPanelOpened.value, "p-multiselect-chevron"]),
        name: "chevron-down",
        size: "xsmall"
      }, null, 8, ["class"])
    ]),
    value: _withCtx((modelValue) => [
      (modelValue.value && modelValue.value.length > 0)
        ? (_openBlock(), _createBlock(_component_joy_tags_list, { key: 0 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modelValue.value, (option) => {
                return (_openBlock(), _createBlock(_component_joy_tag, {
                  key: option,
                  removable: "",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                  onJoyTagRemove: handleOptionRemoved
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(option.label), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 2
          }, 1024))
        : _createCommentVNode("", true),
      (!modelValue.value || modelValue.value.length === 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.completion.wizard.industry.expertise.placeholder')), 1)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "options", "scrollHeight", "placeholder"]))
}
}

})